export default function Component() {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center">
      <div className="flex items-center space-x-4">
        <div className="flex items-center">
          <p className="ml-4 text-lg">
            <b>404</b> | This page could not be found.
          </p>
        </div>
      </div>
    </div>
  );
}
